<template lang="pug">
    v-layout(align-center justify-center row fill-height)
        v-btn(color="primary" to='/') LOGIN
</template>

<script>
export default {
    name: 'login',
    props: {},
    data: function(){
        return {}
    },
    computed: {},
    methods: {},
    watch: {},
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>